<ng-container *transloco="let t">
  <div class="p-dialog-with-toolbar common-lookup-dialog lookup-dialog-content" [ngClass]="lookupId">
    <div class="grid condensed-row">
      <div class="col-12 grid-table overflow-hidden">
        <z-order-inquiry-shipping-detail-dialog-grid></z-order-inquiry-shipping-detail-dialog-grid>
      </div>
    </div>

    <div class="p-dialog-footer p-dialog-footer-toolbar">
      <p-toolbar styleClass="dialog-toolbar">
        <div class="p-toolbar-group-left">
          <p-button
            label="{{ t('order.shipping_details_dialog.dialog.open_tracking') }}"
            styleClass="ml-1 p-button-danger"
            (click)="openTracking()"
            [disabled]="openTrackingButtonDisabled$ | async"
          ></p-button>

          <p-button
            label="{{ t('order.shipping_details_dialog.dialog.copy_tracking') }}"
            styleClass="ml-1 p-button-success p-button-outlined"
            (click)="copyTracking()"
            [disabled]="copyTrackingButtonDisabled$ | async"
          ></p-button>
        </div>

        <div class="p-toolbar-group-right">
          <p-button
            label="{{ t('order.shipping_details_dialog.dialog.cancel') }}"
            styleClass="ml-1 p-button-secondary"
            (click)="close()"
          ></p-button>
        </div>
      </p-toolbar>
    </div>
  </div>
</ng-container>
